<ion-header>
  <ion-toolbar>
    <ion-title>SmartDine Restaurants</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">Cancel</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item
      *ngFor="let restaurant of restaurants"
      (click)="selectRestaurant(restaurant)"
      [ngClass]="{
        selected: restaurant?.restaurantId === selectedRestaurant?.restaurantId
      }"
    >
      <ion-label>{{ restaurant.name }}</ion-label>
    </ion-item>
  </ion-list>

  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadData($event)">
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Loading more data..."
    >
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
